module.exports = __webpack_public_path__ + "img/flo.620286ca.svg";